import { AppBar, Button, InputAdornment, Switch, Toolbar, Typography } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import type { MeterInput, NewMeter } from '@vy/types';
import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { VayuTextField } from '../../../../components/design/vayu-theme-components/VayuTextField';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';

type CreateProductPageAppBarProps = {
  isDescriptionOpen: boolean;
  toggleDescriptionVisibility: () => void;
};

export const CreateProductPageAppBar: React.FC<CreateProductPageAppBarProps> = ({
  isDescriptionOpen,
  toggleDescriptionVisibility,
}) => {
  const navigate = useVyNavigate();
  const { control } = useFormContext<MeterInput, unknown, NewMeter>();

  return (
    <AppBar
      position="static"
      elevation={0}
      sx={(theme) => ({
        backgroundColor: theme.palette.background.paper,
        borderBottom: `1px solid ${theme.palette.divider}`,
        color: theme.palette.text.primary,
      })}
    >
      <Toolbar
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Button
          size="medium"
          variant="contained"
          color="secondary"
          onClick={() => navigate('/products', { replace: true })}
        >
          Close
          <VyIcon
            icon="CloseBig"
            style={{
              transform: 'scale(0.8)',
              marginRight: '-10px',
            }}
          />
        </Button>

        <div className="ml-20">
          <Controller
            control={control}
            name="name"
            render={({ field }) => (
              <VayuTextField
                {...field}
                placeholder="Product name"
                slotProps={{
                  input: {
                    endAdornment: (
                      <InputAdornment
                        position="start"
                        sx={{
                          paddingBottom: '4px',
                          paddingLeft: '8px',
                        }}
                      >
                        <VyIcon icon="Pen" />
                      </InputAdornment>
                    ),
                  },
                }}
              />
            )}
          />
        </div>

        <div className="flex items-center">
          <Typography variant="body1">See Description</Typography>
          <Switch checked={isDescriptionOpen} onChange={() => toggleDescriptionVisibility()} />
        </div>
      </Toolbar>
    </AppBar>
  );
};
